import { useEffect, useMemo, useRef } from "react";
import usePosts from "../usePosts";
import { TABS } from "./Tabs";
import { PostCard } from "./PostCard";
import Spinner from "../../../../components/Spinners";
import { api } from "../../../../helpers/api";
import { useInfiniteQuery } from "@tanstack/react-query";

export function Reviews({ user, refresh, isSalon = false }) {
  // const { posts, isLoading, total, loadMore } = usePosts({
  //   userType: type,
  //   userId,
  // });
  const loadMoreRef = useRef<any>(null);

  const fetchUsers = async ({ pageParam }) => {
    const res = await api.getReviews({
      page: pageParam,
      limit: 10,
      userId: user?.id,
      othersReviews: !isSalon,
    });
    return res?.reviews || [];
  };

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["reviews", user?.id, isSalon],
    queryFn: fetchUsers,
    initialPageParam: 0,
    getNextPageParam: (lastPage, pages, pageParam) => {
      // console.log(lastPage);
      if (lastPage.length < 10) return null;
      return pageParam + 1;
    },
  });
  const observerTarget = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      },
      {
        root: null,
        rootMargin: "20px",
        threshold: 1.0,
      }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const posts = useMemo(() => {
    if (data) {
      // Combine pages into one array
      const newData = data.pages.flatMap((page) => page);
      // Set the combined data into the table data state
      return newData;
    }
  }, [data]);

  console.log(data);
  return (
    <div className="mt-5 flex mx-7 px-3 pb-3 tall:max-h-[575px] max-h-[600px] overflow-auto flex-wrap">
      {!isLoading && posts?.length === 0 && <div>No posts found</div>}
      {/** divide posts in two parts one is odd and second is even */}
      <div className="flex flex-col gap-4 flex-[50%] max-w-[50%] pr-2">
        {posts?.map((post, index) => {
          if (index % 2 === 0) {
            return (
              <PostCard
                user={user}
                key={post.id}
                type={TABS.REVIEWS}
                post={post}
                refresh={() => {
                  refetch();
                  refresh();
                }}
                isSalon={isSalon}
              />
            );
          }
          return null;
        })}
      </div>
      <div className="flex flex-col gap-4 flex-[50%] max-w-[50%] pl-2">
        {posts?.map((post, index) => {
          if (index % 2 !== 0) {
            return (
              <PostCard
                user={user}
                key={post.id}
                type={TABS.REVIEWS}
                post={post}
                refresh={() => {
                  refetch();
                  refresh();
                }}
                isSalon={isSalon}
              />
            );
          }
          return null;
        })}
      </div>
      {/* {(posts || [])?.map((post: any) => (
        <PostCard key={post.id} type={TABS.POSTS} post={post} />
      ))} */}
      {isLoading && (
        <div className="flex justify-center [&_svg]:text-slate-900">
          <Spinner />
        </div>
      )}

      <div className="">
        <button
          onClick={() => fetchNextPage()}
          disabled={!hasNextPage || isFetchingNextPage}
          ref={loadMoreRef}
        >
          {/* {isFetchingNextPage
                ? "Loading more..."
                : hasNextPage
                ? "Load More"
                : "Nothing more to load"} */}
        </button>
      </div>
    </div>
  );
}
